import script from "./rec-checkboxes-selector.vue?vue&type=script&lang=ts&setup=true"
export * from "./rec-checkboxes-selector.vue?vue&type=script&lang=ts&setup=true"

import "./rec-checkboxes-selector.vue?vue&type=style&index=0&id=100bbf44&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-100bbf44"]])

export default __exports__